var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import nem from 'nem-sdk';
import encoding from 'encoding-japanese';
var nemWrapper = /** @class */ (function () {
    function nemWrapper() {
        this.endpoint = '';
        this.host = '';
        this.port = '';
        this.net = '';
        // NIS設定.
        this.host = 'https://aqualife2.supernode.me';
        this.port = '7891';
        this.net = nem.model.network.data.mainnet.id;
        this.endpoint = nem.model.objects.create("endpoint")(this.host, this.port);
    }
    // NISの状態確認.
    nemWrapper.prototype.isNIS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, nem.com.requests.endpoint.heartbeat(this.endpoint)];
                    case 1:
                        result = _a.sent();
                        if (result.message === 'ok') {
                            return [2 /*return*/, true];
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // アカウント作成.
    nemWrapper.prototype.createAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var walletName, password, wallet, common, account, result;
            return __generator(this, function (_a) {
                walletName = "wallet";
                password = "wallet";
                wallet = nem.model.wallet.createPRNG(walletName, password, this.net);
                common = nem.model.objects.create("common")(password, "");
                account = wallet.accounts[0];
                nem.crypto.helpers.passwordToPrivatekey(common, account, account.algo);
                result = {
                    address: account.address,
                    privateKey: common.privateKey
                };
                return [2 /*return*/, result];
            });
        });
    };
    // アカウント情報取得.
    nemWrapper.prototype.getAccount = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, nem.com.requests.account.data(this.endpoint, address)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // 送金（NEM）
    nemWrapper.prototype.sendNem = function (address, privateKey, amount, message) {
        return __awaiter(this, void 0, void 0, function () {
            var common, transferTransaction, transactionEntity, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        common = nem.model.objects.create('common')('', privateKey);
                        transferTransaction = nem.model.objects.create('transferTransaction')(address, amount, message);
                        transactionEntity = nem.model.transactions.prepare('transferTransaction')(common, transferTransaction, this.net);
                        return [4 /*yield*/, nem.model.transactions.send(common, transactionEntity, this.endpoint)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // 送金（Mosaic）
    nemWrapper.prototype.sendMosaics = function (address, privateKey, mosaics, message) {
        return __awaiter(this, void 0, void 0, function () {
            var common, transferTransaction, mosaicDefinitionMetaDataPair, transactionEntity, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        common = nem.model.objects.create('common')('', privateKey);
                        transferTransaction = nem.model.objects.create('transferTransaction')(address, 1, message);
                        return [4 /*yield*/, this.getMosaicDefinitionMetaDataPair(this.endpoint, mosaics)];
                    case 1:
                        mosaicDefinitionMetaDataPair = _a.sent();
                        mosaics.forEach(function (mosaic) {
                            var fullMosaicName = mosaic.namespace + ':' + mosaic.name;
                            if ((mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition.id.namespaceId === mosaic.namespace) &&
                                (mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition.id.name === mosaic.name)) {
                                var divisibility_1 = 0;
                                mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition.properties.forEach(function (prop) {
                                    if (prop.name === 'divisibility') {
                                        divisibility_1 = prop.value;
                                    }
                                });
                                var quantity = mosaic.amount * Math.pow(10, divisibility_1);
                                var mosaicAttachment = nem.model.objects.create('mosaicAttachment')(mosaic.namespace, mosaic.name, quantity);
                                transferTransaction.mosaics.push(mosaicAttachment);
                            }
                        });
                        transactionEntity = nem.model.transactions.prepare('mosaicTransferTransaction')(common, transferTransaction, mosaicDefinitionMetaDataPair, this.net);
                        return [4 /*yield*/, nem.model.transactions.send(common, transactionEntity, this.endpoint)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // モザイク取得
    nemWrapper.prototype.getMosaics = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    // モザイク定義取得.
    nemWrapper.prototype.getMosaicDefinitionMetaDataPair = function (endpoint, mosaics) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var mosaicDefinitionMetaDataPair = nem.model.objects.get('mosaicDefinitionMetaDataPair');
                        var mosaicCount = 0;
                        mosaics.forEach(function (mosaic) {
                            var mosaicAttachment = nem.model.objects.create('mosaicAttachment')(mosaic.namespace, mosaic.name, mosaic.amount);
                            var result = nem.com.requests.namespace.mosaicDefinitions(endpoint, mosaicAttachment.mosaicId.namespaceId)
                                .then(function (result) {
                                mosaicCount = mosaicCount + 1;
                                var neededDefinition = nem.utils.helpers.searchMosaicDefinitionArray(result.data, [mosaic.name]);
                                var fullMosaicName = nem.utils.format.mosaicIdToName(mosaicAttachment.mosaicId);
                                if (undefined === neededDefinition[fullMosaicName]) {
                                    console.error('Mosaic not found !');
                                    return;
                                }
                                mosaicDefinitionMetaDataPair[fullMosaicName] = {};
                                mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition = neededDefinition[fullMosaicName];
                                var supply = 0;
                                result.data.some(function (obj) {
                                    if ((obj.mosaic.id.namespaceId === mosaic.namespace) &&
                                        (obj.mosaic.id.name === mosaic.name)) {
                                        obj.mosaic.properties.some(function (prop) {
                                            if (prop.name === 'initialSupply') {
                                                supply = prop.value;
                                                return true;
                                            }
                                        });
                                    }
                                });
                                mosaicDefinitionMetaDataPair[fullMosaicName].supply = supply;
                                if (mosaicCount >= mosaics.length) {
                                    resolve(mosaicDefinitionMetaDataPair);
                                }
                            }).catch(function (e) {
                                console.error(e);
                                reject(e);
                            });
                        });
                    })];
            });
        });
    };
    // QRコードjson取得.
    nemWrapper.prototype.getQRcodeJson = function (v, type, name, addr, amount, msg) {
        // v:2, type:1 アカウント, type:2 請求書
        var amountVal = amount * Math.pow(10, 6);
        var json = {
            type: type,
            data: {
                name: name,
                addr: addr,
                amount: amountVal,
                msg: msg
            },
            v: v
        };
        var jsonString = JSON.stringify(json);
        var result = encoding.codeToString(encoding.convert(this.getStr2Array(jsonString), 'UTF8'));
        return result;
    };
    // NEMの可分性取得
    nemWrapper.prototype.getNemDivisibility = function () {
        return Math.pow(10, 6);
    };
    nemWrapper.prototype.getStr2Array = function (str) {
        var array = [];
        for (var i = 0; i < str.length; i++) {
            array.push(str.charCodeAt(i));
        }
        return array;
    };
    return nemWrapper;
}());
export default nemWrapper;



//////////////////
// WEBPACK FOOTER
// ./src/ts/nemWrapper.ts
// module id = 133
// module chunks = 1